export default function SectionOnDemand({ _data }) {
  return (
    <div
      className="section-full  p-b30 p-t90 tw-booking-area tw-booking-area-bg-wrap"
      // style={{ backgroundImage: `url(${_data.background})` }}
    >
      <div className="container">
        <div className="tw-booking-section">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="tw-booking-media">
                <div className="media">
                  <div className="wt-small-separator site-text-primary">
                    <div>{_data.title}</div>
                  </div>
                  {/* <h2 className="wt-title">{_data.subtitle}</h2> */}
                  <h4 className="wt-title">{_data.subtitle}</h4>

                  <div className="tw-booking-images d-flex gap-3 mt-4">
                    <img
                      src="/assets/images/ondemand3.png"
                      alt="On-demand booking illustration 1"
                      className="img-fluid"
                      style={{ width: "30%" }}
                    />
                    <img
                      src="/assets/images/ondemand2.png"
                      alt="On-demand booking illustration 3"
                      className="img-fluid"
                      style={{ width: "30%" }}
                    />
                    <img
                      src="/assets/images/ondemand1.png"
                      alt="On-demand booking illustration 2"
                      className="img-fluid"
                      style={{ width: "30%" }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 text-center">
              <img
                className="map-view img-fluid m-t60"
                src="/assets/images/ondemand.png"
                alt=""
                width="100%"
              />
              {/* <p className="section-head-text">{_data.description}</p> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
